// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-badge[data-v-0a6a804e]{bottom:.25rem;height:.625rem;right:-.2rem;width:.625rem}.reminder-modal[data-v-0a6a804e]{left:50%;transform:translateX(-50%)}@media screen and (max-width:1500px){.reminder-modal[data-v-0a6a804e]{left:auto;right:-160px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
